import { gql } from '@apollo/client'

export default gql`
  mutation archiveGroup($id: ID!) {
    updateGroup(id: $id, archived: true) {
      id
      name
      color
      archived
    }
  }
`
